exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonGrid__ORBModal-module___3QYQt {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  grid-gap: 8px;\n}\n.buttonContainer__ORBModal-module___GtvZV {\n  flex-shrink: 0;\n}\n\n.inputContainer__ORBModal-module___1mxet {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.buttonContainerRDW__ORBModal-module___jCW0x {\n  flex-shrink: 0;\n}\n\n@media (max-width: 375px) {\n  .inputContainer__ORBModal-module___1mxet {\n    flex-wrap: wrap;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"buttonGrid": "buttonGrid__ORBModal-module___3QYQt",
	"buttonContainer": "buttonContainer__ORBModal-module___GtvZV",
	"inputContainer": "inputContainer__ORBModal-module___1mxet",
	"buttonContainerRDW": "buttonContainerRDW__ORBModal-module___jCW0x"
};